'use client';
import { useState } from 'react';

import { ControlledSegmentedControl, type ControlledSegmentedControlProps } from './ControlledSegmentedControl';

export type SegmentedControlProps = Omit<ControlledSegmentedControlProps, 'onChangeSelected' | 'selected'> & {
	defaultSelected: string;
};
/**
 * SegmentedControl component - uncontrolled version
 * @param {Array<ItemTabProps>} items array of Items, text and Id
 * @param {string} testID
 * @param {string} defaultSelected defaultSelected tab
 * @param props Rest of props
 *
 */
export const SegmentedControl = ({ className, defaultSelected, ...args }: SegmentedControlProps) => {
	const [selected, setSelected] = useState<string>(defaultSelected);

	return (
		<ControlledSegmentedControl
			{...args}
			className={className}
			selected={selected}
			onChangeSelected={setSelected}
		/>
	);
};
